module.exports = __webpack_public_path__ + "img/SEJ_Eventos_PDF.7688010f.svg";